module.exports = __webpack_public_path__ + "static/media/dolphins-silhouette.5b178fe3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/dolphins-silhouette.svg
// module id = 1340
// module chunks = 0